import { c as _c } from "react/compiler-runtime";
import { getInstanceSpaceSlug } from '@shared/all/domains/spaces';
import { usePathname } from 'next/navigation';
import { spaceConfig } from '../utils/getSpaceConfig';

// The space this page is standing in, if any. Mobile's twin is the
// `instanceSpaceSlug` constant in its `utils/getSpaceConfig`.
export const useInstanceSpaceSlug = () => {
  const $ = _c(2);
  const t0 = usePathname();
  let t1;
  if ($[0] !== t0) {
    t1 = getInstanceSpaceSlug(spaceConfig, t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};